import React, { useState } from 'react'
import TicketForm, {
  TicketInputDataType,
  TicketOutputDataType,
} from '../components/forms/TicketForm'
import { AttachmentType, CaseReportId } from '../models'

const caseReportId: CaseReportId = '123'

const initialAccidentData: TicketInputDataType = {
  caseCommon: {
    description: 'case common description',
  },
  caseTI: {
    attachmentList: [
      {
        attachmentType: AttachmentType.PHOTO,
        attachments: [
          {
            attachmentId: '124',
            fileName: 'muj ticket.pdf',
          },
        ],
      },
      {
        attachmentType: AttachmentType.SUPPORT,
        attachments: [
          {
            attachmentId: '124',
            fileName: 'muj ticket.pdf',
          },
        ],
      },
    ],
  },
}

const AccidentDebug = () => {
  const [ticketFormData, setTicketFormData] =
    useState<TicketInputDataType>(initialAccidentData)

  const handleTicketPageSubmitted = (value: TicketOutputDataType) => {
    console.log('Form submitted: ', value)
    alert('DEBUG\nForm submitted\nNow the page will be reset to blank data...')

    // reset data in the form to empty data
    setTicketFormData({
      caseTI: {}, // set damageType => LOSS so that we see the Attachments component being updated
    })

    // delay 10 sec
    new Promise((resolve) => setTimeout(resolve, 10000)).then(() => {
      alert('DEBUG\nNow we will display the previously edited values...')
      setTicketFormData(value)
    })
  }

  const handleTicketPageBack = () => {
    alert('Page back')
  }

  return (
    <TicketForm
      caseReportId={caseReportId}
      data={ticketFormData}
      isPageConfirmInProgress={false}
      errorMessage={''}
      onPageContinue={handleTicketPageSubmitted}
      onPageBack={handleTicketPageBack}
      notifyDataChanged={(isChanged: boolean) => {
        /* ignore */
      }}
    />
  )
}

export default AccidentDebug
